import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-placeholders-2',
  templateUrl: './2.component.html',
  styleUrls: ['./2.component.scss'],
})
export class VbPlaceholders2Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
